const csvDataBuilder = (arr) => {
  let res = [['Operação', 'Data', 'Valor', 'Pedido', 'Observações']]
  arr?.forEach((element) => {
    res.push(objectToCSVArray(element))
  })
  return res
}

const objectToCSVArray = (data) => {
  let res = []
  res[0] = data.tipoOperacao
  res[1] = data.data + data.hora
  res[2] = data.totalPedido
  res[3] = data.pedidoId
  res[4] = data.descricao
  return res
}

export default csvDataBuilder
